import type { Editor, Location } from 'slate';

import type { AlineText, EditingMode } from '../internal';
import { AlineTransforms } from '../internal';

const ColorTransforms = {
  applyFontColor: (
    editor: Editor,
    options: {
      authorId: string;
      color: AlineText['fontColor']['color'];
      editingMode: EditingMode;
      at?: Location;
      voids?: boolean;
    }
  ): void => {
    AlineTransforms.withoutNormalizing(editor, () => {
      const { at = editor.selection, authorId, color, editingMode, voids = true } = options;
      if (!at) return;

      const newFontColor: Pick<AlineText, 'fontColor'> = {
        fontColor: {
          color,
          origin: 'USER_APPLIED',
        },
      };

      AlineTransforms.setTextProps(editor, {
        at,
        authorId,
        editingMode,
        textProps: newFontColor,
        voids,
      });
    });
  },
  applyHighlightColor: (
    editor: Editor,
    options: {
      authorId: string;
      color: AlineText['highlight']['color'];
      editingMode: EditingMode;
      at?: Location;
      voids?: boolean;
    }
  ): void => {
    AlineTransforms.withoutNormalizing(editor, () => {
      const { at = editor.selection, authorId, color, editingMode, voids = true } = options;
      if (!at) return;

      const newHighlight: Pick<AlineText, 'highlight'> = {
        highlight: {
          color,
          origin: 'USER_APPLIED',
        },
      };

      AlineTransforms.setTextProps(editor, {
        at,
        authorId,
        editingMode,
        textProps: newHighlight,
        voids,
      });
    });
  },
};

export default ColorTransforms;
